"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLineSizePricingBandForLineSizeCents = resolveLineSizePricingBandForLineSizeCents;
const math_1 = require("./math");
function getPricingBandBoundsCents(band) {
    return {
        minLineSizeCents: (0, math_1.roundDecimalProduct)(band.minLineSize, 100),
        maxLineSizeCents: (0, math_1.roundDecimalProduct)(band.maxLineSize, 100),
    };
}
function bandContainsLineSizeCents(band, lineSizeCents) {
    const { minLineSizeCents, maxLineSizeCents } = getPricingBandBoundsCents(band);
    return lineSizeCents >= minLineSizeCents && lineSizeCents <= maxLineSizeCents;
}
function resolveLineSizePricingBandForLineSizeCents(lineSizePricingBands, lineSizeCents) {
    return lineSizePricingBands?.find((band) => bandContainsLineSizeCents(band, lineSizeCents)) ?? null;
}
